import { bb } from "$json";
/* modes:
 *
 * Set modes according to indisputable server data or according to
 * regular expression matching the current modelname + '/' + graphname + '/' + nodename.
 *
 * An end-of-string is automatically appended after the provided
 * regular expressions.
 *
 * If the mode has Camel-Cased word 'No' in it, a global data property
 * withOut that, and set to false will deem the mode to be positive.

 * e.g. mode 'hasNoNext' will be set (true) when data.hasnext is false.
 *
 * This is a generic replacement of has-no-next and siblings.
 *
 * Author: Niels Giesen
 *
 * Copyright (C) 2011, 2012, 2019 by Berkeley Bridge
 *
 */

(function ($) {
  var modes;
  var negatingre = /[a-z]No[a-z]/;
  try {
    modes = bb.conf.arbitrary["modes"];
    Object.keys(modes).forEach(function (mode) {
      modes[mode].nodes.forEach(function (node, i, arr) {
        arr[i] = new RegExp(node + "$");
      });
    });
  } catch (e) {}

  if (!modes || Object.keys(modes).length === 0) return;

  function test(mode, data, name, nodes) {
    if (negatingre.test(mode)) {
      var prop = mode.split("No").join("").toLowerCase();
    }
    if (prop && data.hasOwnProperty(prop) && data[prop] === false) return true;
    else {
      return nodes.some(function (re) {
        return re.test(name);
      });
    }
  }

  $(document).on("bb:postHandleData", function (event, data) {
    if (data && data.groups) {
      var group = data.groups.find(function (group) {
        return group.current;
      });
      var name = data.modelname + "/" + group.name.split(".").join("/");
      Object.keys(modes).forEach(function (mode) {
        bb.Mode.toggle(mode, test(mode, data, name, modes[mode].nodes));
      });
    }
  });
})(jQuery);
